import { ContextType, createContext, RefObject, useContext } from "react";

export type DashboardContextType = {
  isTwoPanel: boolean;
  getParentScrollPosition: () => number;
  setParentScrollPosition: (scrollTop: number) => void;
  singlePartRef: RefObject<HTMLDivElement | null> | null;
};

export const DashboardContext = createContext<DashboardContextType>({
  isTwoPanel: false,
  getParentScrollPosition: () => 0,
  setParentScrollPosition: () => undefined,
  singlePartRef: null,
});

export const useDashboardContext = (): ContextType<typeof DashboardContext> =>
  useContext(DashboardContext);
